/**
 * Avatar Preview Context - Simple React Context for real-time avatar preview sync
 * Used to sync avatar form data between AvatarPage and Header
 */

import { createContext, useContext, useState, ReactNode } from 'react'

interface AvatarPreviewData {
  profileImage?: string | null
  displayName?: string
  alias?: string
}

interface AvatarPreviewContextType {
  avatarPreview: AvatarPreviewData | null
  setAvatarPreview: (data: AvatarPreviewData | null) => void
}

const AvatarPreviewContext = createContext<AvatarPreviewContextType | undefined>(undefined)

export function AvatarPreviewProvider({ children }: { children: ReactNode }) {
  const [avatarPreview, setAvatarPreview] = useState<AvatarPreviewData | null>(null)

  return (
    <AvatarPreviewContext.Provider value={{ avatarPreview, setAvatarPreview }}>
      {children}
    </AvatarPreviewContext.Provider>
  )
}

export function useAvatarPreview() {
  const context = useContext(AvatarPreviewContext)
  if (context === undefined) {
    throw new Error('useAvatarPreview must be used within an AvatarPreviewProvider')
  }
  return context
}